module.exports = __webpack_public_path__ + "static/marykay-logo-c17560fa3928110282bba04a2c58c9b7.png";